import React from 'react';
import { PILL, ROW_BUTTON } from '../liStyles';

// One place in a list — name, kind, how far, hours, whether it is ready to send
// guests, and any staff note. The whole row opens the place.
const PlaceRow = ({ place, onOpen }) => {
  if (!place) return null;
  // Closed and new rows carry only `label` / `since_label`; place rows carry the rest.
  const meta = [place.category_label, place.distance_label, place.hours_label, place.label, place.since_label]
    .filter(Boolean).join(' · ');
  return (
    <button type="button" className={ROW_BUTTON} onClick={() => onOpen(place)} data-testid="li-place-row">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">
            {place.featured && <span className="text-[#32B1FF]" title="Featured by staff">★ </span>}
            {place.name}
          </div>
          {meta && <div className="text-sm text-gray-600 dark:text-gray-400">{meta}</div>}
          {place.note_label && <div className="text-sm text-gray-500 dark:text-gray-400 italic">{place.note_label}</div>}
        </div>
        <div className="flex flex-col items-end gap-1 shrink-0">
          {place.open_now && <span className={PILL.emerald}>Open</span>}
          {place.rating_label && <span className="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">{place.rating_label}</span>}
          {place.guest_ready === false && place.guest_ready_label && <span className={PILL.gray}>{place.guest_ready_label}</span>}
        </div>
      </div>
    </button>
  );
};

export default PlaceRow;
